import { Link, useLocation } from "@tanstack/react-router";
import type React from "react";
import { memo } from "react";
import { SidebarMenuButton } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";

interface StaticSidebarButtonProps {
    to: "/inbox" | "/assigned-to-me" | "/created-by-me" | "/all";
    disabled?: boolean;
    label: string;
    icon: React.ElementType;
}

export const StaticSidebarButton = memo(({ to, disabled, label, ...rest }: StaticSidebarButtonProps) => {
    const location = useLocation();
    const isActive = location.pathname === to;

    return (
        <SidebarMenuButton
            render={
                <Link
                    to={to}
                    className={cn([
                        {
                            "opacity-50 pointer-events-none": disabled,
                        },
                    ])}
                >
                    <rest.icon />
                    <span>{label}</span>
                </Link>
            }
            isActive={isActive}
        ></SidebarMenuButton>
    );
});
